const initialState = {
  trackedPendingReports: {},
  unreadReportIds: [],
  reportNotificationEnabled: true,
};

const uniqueIds = (ids = []) => [...new Set(ids.filter(Boolean))];

const inHouseReportNotificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INITIALIZE_IN_HOUSE_REPORT_NOTIFICATIONS":
      return {
        ...state,
        trackedPendingReports: action.payload || {},
      };

    case "SYNC_IN_HOUSE_REPORT_NOTIFICATIONS_TRACKER":
      return {
        ...state,
        trackedPendingReports: action.payload || {},
      };

    case "RECEIVE_IN_HOUSE_REPORT_NOTIFICATIONS": {
      const newIds = uniqueIds(action.payload);

      if (!newIds.length) return state;

      return {
        ...state,
        unreadReportIds: uniqueIds([...newIds, ...state.unreadReportIds]),
      };
    }

    case "MARK_IN_HOUSE_REPORT_NOTIFICATIONS_READ": {
      const idsToClear = new Set(uniqueIds(action.payload));

      if (!idsToClear.size) {
        return { ...state, unreadReportIds: [] };
      }

      return {
        ...state,
        unreadReportIds: state.unreadReportIds.filter(
          (id) => !idsToClear.has(id),
        ),
      };
    }

    case "SET_IN_HOUSE_REPORT_NOTIFICATION_PREFERENCE":
      return {
        ...state,
        reportNotificationEnabled: action.payload !== false,
      };

    case "SIGNOUT":
      return initialState;

    default:
      return state;
  }
};

export default inHouseReportNotificationsReducer;
